module.exports = __webpack_public_path__ + "static/media/heart.ea86d033.svg";